import { DirectionalHint, IKeytipProps, memoizeFunction } from '@fluentui/react';

import { getDefaultKeytipProps } from '@1js/acui-keytip';

const tabInMenuOffset = 5; // When in the overflow well, keytip should be positioned 5px from the right of the menu

export const deriveTabMenuKeytip = memoizeFunction(
  (keytipProps?: IKeytipProps, onExecute?: (executeTarget: HTMLElement) => void): IKeytipProps | undefined => {
    return keytipProps
      ? getDefaultKeytipProps(keytipProps, tabInMenuOffset, onExecute, DirectionalHint.rightCenter)
      : undefined;
  }
);
